import styled from 'styled-components';

export const PageContainer = styled.div`
  display: grid;
  grid: 1fr / 3fr 5fr;
  min-height: 100vh;
  font-size: 20px;
  
  @media screen and (min-width: 2750px) {
    font-size: 28px;
  }

  @media screen and (max-width: 1200px) and (min-height: 600px) {
    font-size: 16px;
  }

  @media screen and (max-height: 600px) {
    font-size: 14px;
  }

  @media screen and (max-width: 330px) {
    font-size: 14px;
  }

  @media screen and (max-width: 780px) {
    display: flex;
    justify-content: center;
  }
`;
